var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_16146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3726 2.57031C14.6812 2.57031 14.1226 3.12891 14.1226 3.82031C14.1226 4.51172 14.6812 5.07031 15.3726 5.07031H18.603L10.7397 12.9375C10.2515 13.4258 10.2515 14.2188 10.7397 14.707C11.228 15.1953 12.021 15.1953 12.5093 14.707L20.3726 6.83984V10.0703C20.3726 10.7617 20.9312 11.3203 21.6226 11.3203C22.314 11.3203 22.8726 10.7617 22.8726 10.0703V3.82031C22.8726 3.12891 22.314 2.57031 21.6226 2.57031H15.3726ZM5.99756 3.82031C4.271 3.82031 2.87256 5.21875 2.87256 6.94531V19.4453C2.87256 21.1719 4.271 22.5703 5.99756 22.5703H18.4976C20.2241 22.5703 21.6226 21.1719 21.6226 19.4453V15.0703C21.6226 14.3789 21.064 13.8203 20.3726 13.8203C19.6812 13.8203 19.1226 14.3789 19.1226 15.0703V19.4453C19.1226 19.7891 18.8413 20.0703 18.4976 20.0703H5.99756C5.65381 20.0703 5.37256 19.7891 5.37256 19.4453V6.94531C5.37256 6.60156 5.65381 6.32031 5.99756 6.32031H10.3726C11.064 6.32031 11.6226 5.76172 11.6226 5.07031C11.6226 4.37891 11.064 3.82031 10.3726 3.82031H5.99756Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_16146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2.87256 2.57031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkField);
export default __webpack_public_path__ + "static/media/link-field.cbf92403f3ab06fba970260b02b3b963.svg";
export { ForwardRef as ReactComponent };